module.exports = __webpack_public_path__ + "img/苍南教育局.61251bba.png";